// extracted by mini-css-extract-plugin
module.exports = {"logoBorder":"Navbar_logoBorder__-ye4a","navBg":"Navbar_navBg__1bW0i"};